// extracted by mini-css-extract-plugin
export default {"contact":"contact__Nj0Fn","terms":"terms__SbSZF","socials":"socials__q8jm-","linkedin":"linkedin__W7-FL","github":"github__naQMf","logo":"logo__N4ZnV"};